import { useQuery } from '@apollo/client';
import { GET_AVERAGE_ANNUAL_DEMAND_PER_ERC } from '../../../queries/engineeringQrys';

/**
 * Data for the DWRi Calculations tab.
 * @param {string} pwsId - The full PWS ID (e.g., "UTAH12345")
 * @param {number[]} years - Array of years to fetch data for
 * @param {string[]} selectedSources - Optional array of selected source IDs
 */
const useDwriCalculationsData = ({ pwsId, years, selectedSources = [] }) => {
    const skipYearBased = !pwsId || years.length === 0;
    const sourceFilter = selectedSources.length > 0 ? selectedSources : undefined;

    const {
        data: averageAnnualDemandData,
        loading: averageAnnualDemandLoading,
        error: averageAnnualDemandError,
    } = useQuery(GET_AVERAGE_ANNUAL_DEMAND_PER_ERC, {
        variables: { pwsId, years, sources: sourceFilter },
        skip: skipYearBased,
        fetchPolicy: 'cache-and-network',
    });

    return {
        averageAnnualDemandRows: averageAnnualDemandData?.getAverageAnnualDemandPerErc || [],
        loading: {
            averageAnnualDemand: averageAnnualDemandLoading,
        },
        errors: {
            averageAnnualDemand: averageAnnualDemandError,
        },
    };
};

export default useDwriCalculationsData;
